var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_92_1539)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9412 11.2941V0H0V21.1765H14.1176V24H24V11.2941H16.9412ZM1.41176 19.7647V1.41176H15.5294V11.2941H14.1176V19.7647H1.41176ZM22.5882 22.5882H15.5294V12.7059H22.5882V22.5882Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9414 19.7646H18.3532V21.1764H16.9414V19.7646Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7646 19.7646H21.1764V21.1764H19.7646V19.7646Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9414 16.9414H18.3532V18.3532H16.9414V16.9414Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7646 16.9414H21.1764V18.3532H19.7646V16.9414Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9414 14.1177H21.1767V15.5294H16.9414V14.1177Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.82324 11.2939H11.2938V12.7057H2.82324V11.2939Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.82324 8.4707H9.17618V9.88247H2.82324V8.4707Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.82324 5.64697H14.1174V7.05874H2.82324V5.64697Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.82324 2.82373H14.1174V4.2355H2.82324V2.82373Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.64677 14.1177H4.23501V15.5294H2.82324V16.9412H4.23501V18.353H5.64677V16.9412H7.05854V15.5294H5.64677V14.1177Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.4707 16.9414H11.2942V18.3532H8.4707V16.9414Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.4707 14.1177H11.2942V15.5294H8.4707V14.1177Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_92_1539"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.368f8c567c236207c6bb552618196cb8.svg";
export { ForwardRef as ReactComponent };